module.exports = __webpack_public_path__ + "static/media/vuejs.d79a1432.svg";